<template>
    <div style="flex:1; overflow:hidden;" @touchmove.stop="() => {}">
        <div style="flex:1; display:flex; flex-direction:column;background-color: white; border-top-left-radius:24px; border-top-right-radius:24px; position:relative; overflow:hidden;">
            <div v-if="isShowCloseBtn">
                <div @click="close" style="display:inline-block; padding:20px 20px; color:#808080; font-size:16px; font-weight:bold;">닫기</div>
            </div>
            <div style="flex:1; overflow:auto; padding:0px 30px; ">
                <div v-if="!isShowCloseBtn" style="height:20px;"></div>
                <div style="color:#210F03; font-size:32px; font-weight:bold; margin-top:30px;text-align:center;">축구하러 오신 회원님,</div>
                <div style="color:#210F03; font-size:32px; font-weight:bold; margin-top:10px;text-align:center;">반갑습니다!</div>
                <div style="color:#210F03; font-size:16px; font-weight:500; margin-top:25px;text-align:center;">계정을 만들기 전 회원 유형을 선택하세요</div>
                <div style="color:#808080; font-size:12px; font-weight:500; margin-top:5px; text-align:center;line-height:18px;">학생, 아마추어, 일반 축구 팬, 엘리트 선수라면 일반 회원,<br>선수 출신이거나 축구 코치라면 전문가 회원을 선택하세요</div>
                <div @click="select(MEMBER_TYPE.USER)" style="display:grid; place-items: center; text-align:center; width:100%; height:180px;background: linear-gradient(180deg, #FFA264 0%, #AB4500 100%);border: 1px solid #D9D9D9;border-radius: 24px; margin-top:40px;">
                    <div style="width: calc(100% - 40px);">
                        <div style="color:white; font-weight:bold; font-size:16px;">일반 회원</div>
                        <div style=" width:100%; color:#210F03;font-weight:bold; font-size:14px; margin-top:20px;background: #FFDAC2;height: 44px; display:grid;padding: 10px; place-items: center;border-radius: 12px;">취미, 팬, 학생 등 일반 회원</div>
                    </div>
                </div>
                <div @click="select(MEMBER_TYPE.COACH)" style="display:grid; place-items: center; text-align:center; width:100%; height:200px;background: linear-gradient(180deg, #466091 0%, #0D2146 100%);border: 1px solid #D9D9D9;border-radius: 24px; margin-top:30px;">
                    <div style="width: calc(100% - 40px);">
                        <div><img :src="require('@/assets/img/coach_star_yellow.png')" style="width:16px; height:16px;"></div>
                        <div style="color:white; font-weight:bold; font-size:16px; margin-top:10px;">축구 전문가 회원</div>
                        <div style=" width:100%; color:#210F03;font-weight:bold; font-size:14px; margin-top:20px;background: #CADBFC;height: 44px; display:grid;padding: 10px; place-items: center;border-radius: 12px;">선수 출신, 축구 코치, 감동 등 축구 전문가 회원</div>
                    </div>
                </div>
                <div style="height:30px;"></div>
                <template v-if="isExistLoginBtn">
                    <div style="border-radius:12px; background-color:#F5F5F5; height:48px; display:grid; place-items: center; color:#210F03; font-weight:bold; font-size:14px;" @click="showLogin">로그인하기</div>
                    <div style="height:30px;"></div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
    import {MEMBER_TYPE} from "../../Constants";

    export default {
        name: "MemberTypeSelect",
        props : {
            isExistLoginBtn : {
                type : Boolean,
                default : false,
            },
            isShowCloseBtn : {
                type : Boolean,
                default : true,
            },
            isCloseTwice : {
                type : Boolean,
                default : false
            },
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        data(){
            return {
                MEMBER_TYPE : MEMBER_TYPE
            }
        },
        mounted(){
            // this.$GlobalStore.closeLastModal();
            // this.completeAction(MEMBER_TYPE.USER);
        },
        methods : {
            showLogin(){
                this.$GlobalStore.addModal('Login', { transitionName: 'bottom' });
            },
            select(register_type){
                if(this.isExistLoginBtn){
                    sessionStorage.setItem('register_type', register_type);
                }else {
                    sessionStorage.removeItem('register_type')
                }

                if(this.isShowCloseBtn) this.$GlobalStore.closeLastModal();
                this.completeAction(register_type);
            },
            close(){
                if(this.isCloseTwice){
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.closeLastModal();
                } else {
                    this.$GlobalStore.closeLastModal();
                }
            }
        }
    }
</script>

<style scoped>

</style>